import { render, staticRenderFns } from "./AgreementRulesTable.vue?vue&type=template&id=20679cd9&scoped=true&"
import script from "./AgreementRulesTable.vue?vue&type=script&lang=js&"
export * from "./AgreementRulesTable.vue?vue&type=script&lang=js&"
import style0 from "./AgreementRulesTable.vue?vue&type=style&index=0&id=20679cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20679cd9",
  null
  
)

export default component.exports